import { render, staticRenderFns } from "./ShopSettings.vue?vue&type=template&id=8de5b0a8&scoped=true&"
import script from "./ShopSettings.vue?vue&type=script&lang=js&"
export * from "./ShopSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de5b0a8",
  null
  
)

export default component.exports